export const appName = process.env.REACT_APP_NAME;
